import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import '../../css/billstyle.css'
import {useDispatch, useSelector } from 'react-redux';
import {fatchLRAPI,fatchSignAPI,fatchUserAPI,fatchPhotoAPI,EditQuotationAPI,fatchTearmsAPI,fatchBankAPI} from '../../redux/actionCreation';
import { parseISO, format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css'; // Import the styles
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet';
import html2pdf from 'html2pdf.js';
import Loader from '../Loader';
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import LrEditPop from '../lr/LrEditPop';
// 1. Top par import karein
import { PDFDownloadLink } from '@react-pdf/renderer';
import QuotationPDFTemplate from './QuotationPDFTemplate';
import LrdesignConsignor from './LrdesignConsignor';
import LrdesignConsignee from './LrdesignConsignee';
import LrdesignDriverCopy from './LrdesignDriverCopy';
import LrdesignTransport from './LrdesignTransport';

// import LrConsignorCopy from './LrConsignorCopy';


function Lrdesign() {
    //view port set
    useEffect(() => {
        // Update the viewport meta tag when ABCComponent mounts
        const metaTag = document.querySelector('meta[name="viewport"]');
        if (metaTag) {
          metaTag.setAttribute('content', 'width=device-width, initial-scale=0.4, maximum-scale=1.0, user-scalable=yes');
        }
    
        // Clean up function to reset the viewport when ABCComponent unmounts
        return () => {
          if (metaTag) {
            metaTag.setAttribute('content', 'width=device-width, initial-scale=1');
          }
        };
      }, []); // Run only once on component mount
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [loading_update, setLoading_update] = useState(false);
    const dispatchFetchPhoto = useDispatch();
    const [selectedLrId, setselectedLrId] = useState(null);
    const [filteredQuote, setFilteredLr] = useState([]);
    const ref2 = useRef(null);

    const fetchLrIdReducers = useSelector(state => state.fetchLrIdReducers);
    const LrData = fetchLrIdReducers.data;
    const fetchLrReducers = useSelector(state => state.fetchLrReducers);
    const FeatchTearmsReducers = useSelector(state => state.FeatchTearmsReducers);
    
    const FetchBankReducers = useSelector(state => state.FetchBankReducers);
    const signatures = useSelector((state) => state.fetchReducers);
    const hasSignature = signatures.data.some(signature => signature.signature_data);
    const fetchcompanyLogo = useSelector(state => state.fetchcompanyLogo);
    const error_edit = useSelector(state => state.EditQuotationReducers.error?.edit_quotation_errors) ?? null;

    const fetchUserReducres = useSelector(state => state.fetchUserReducres);
    const email = fetchUserReducres.data ? fetchUserReducres.data.email : null;
    const company_name = fetchUserReducres.data ? fetchUserReducres.data.company_name : null;
    const phone_number = fetchUserReducres.data ? fetchUserReducres.data.phone_number : null;
    const phone_number_2 = fetchUserReducres.data ? fetchUserReducres.data.phone_number_2 : null;
    const company_website = fetchUserReducres.data ? fetchUserReducres.data.company_website : null;
    const company_GST = fetchUserReducres.data ? fetchUserReducres.data.company_GST : null;
    const company_add = fetchUserReducres.data ? fetchUserReducres.data.company_add : null;
    const navigate = useNavigate();
    useEffect(()=>{
        if(!localStorage.getItem('tokan')){
            navigate('/login');
        }
    }, []);

    useEffect(() => {
        const fetchDataUser = async () => {
            try {
                const res = await dispatch(fatchUserAPI());
            } catch (error) {
                console.error('Error fetching Company Details data:', error);
            }
        };
        fetchDataUser();
    }, []);

    useEffect(() => {
            const fetchData = async () => {
                setLoading(true);
                try {
                    const res = await dispatch(fatchLRAPI());
                    setLoading(false);
                } catch (error) {
                    setLoading(false);
                    console.log('Error fetching data:', error);
                }
            };
            fetchData(); // Call the async function
        }, []);

    useEffect(() => {
        const fetchDataSign = async () => {
            try {
                const res = await dispatch(fatchSignAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataSign(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchPhoto = async () => {
            try {
              const res = await dispatchFetchPhoto(fatchPhotoAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchPhoto(); // Call the async function
    }, []);
    
    useEffect(() => {
        const fetchBank = async () => {
            try {
                const res = await dispatch(fatchBankAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchBank(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchDataTearms = async () => {
            try {
                const res = await dispatch(fatchTearmsAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataTearms(); // Call the async function
    }, []);

     const today = new Date();
  today.setHours(0, 0, 0, 0);

    // Update Quotation Function
   const [formData, setFormData] = useState({
       lr_date: today,
       lr_num: "",
       risk_type: "AT OWNER'S RISK",
       truck_number: "",
   
       driver_name: "",
       driver_phone: "",
       driver_licence: "",
   
       consignor_name: "",
       consignor_phone: "",
       consignor_gst: "",
       consignor_state: "",
       consignor_city: "",
       consignor_add: "",
   
       consignee_name: "",
       consignee_phone: "",
       consignee_gst: "",
       consignee_state: "",
       consignee_city: "",
       consignee_add: "",
   
       no_package: "",
       ac_weight: "",
       ac_weight_type: "KG",
       char_weight: "",
       charg_weight_type: "KG",
       pack_condition: "ALL ITEMS IN GOOD CONDITION",
       pack_desc: "",
       remark: "",
   
       f_to_bill: "",
       f_paid: "",
       f_to_pay: "",
       total_basic_f: "",
   
       loading_charge: "",
       unloading_charge: "",
       st_charge: "",
       other_charge: "",
       lrcn_charge: "",
   
       gst_per: "18",
       gst_paid_by: "Exempted",
   
       material_Insu: "Insured",
       insu_company: "",
       policy_num: "",
       insu_date: today,
       insu_amount: "",
       insu_risk: "",
   
       demurrage_charge: "500",
       demurrage_type: "Per Day",
       demurrage_time: "More Than 5 Day",
     });

         // Function to calculate total of specified fields
//    const calculateTotal = () => {
//     const {
//         transportation_charge,
//         packing_charge,
//         unpacking_charge,
//         loading_charge,
//         unloading_charge,
//         insurance_charge,
//         storage_charge,
//         other_charge
//     } = formData;

//     const total =
//       parseFloat(transportation_charge) +
//       parseFloat(packing_charge) +
//       parseFloat(unpacking_charge) +
//       parseFloat(loading_charge) +
//       parseFloat(unloading_charge) +
//       parseFloat(insurance_charge) +
//       parseFloat(storage_charge) +
//       parseFloat(other_charge);
//     return total;
//   };

//      // Function to calculate SGST charge based on total and cgst_per
//      const calculateSGSTCharge = (total, sgstPercentage) => {
//         return (total * parseFloat(sgstPercentage)) / 100;
//     };

//     // Function to calculate CGST charge based on total and cgst_per
//     const calculateCGSTCharge = (total, cgstPercentage) => {
//         return (total * parseFloat(cgstPercentage)) / 100;
//     };
    
//     // Function to calculate IGST charge based on total and gst_per
//     const calculateGSTCharge = (total, gstPercentage) => {
//         return (total * parseFloat(gstPercentage)) / 100;
//     };
  
    // useEffect to watch for changes in relevant fields and recalculate charges
    // useEffect(() => {
    //     const total = calculateTotal();
    //     const gstCharge = calculateGSTCharge(total, formData.gst_per);
    //     const cgstCharge = calculateCGSTCharge(total, formData.cgst_per);
    //     const sgstCharge = calculateSGSTCharge(total, formData.sgst_per);
    //     // Update state with the calculated values
    //     setFormData((prevData) => ({
    //     ...prevData,
    //     total_charge:total.toFixed(2),
    //     gst_charge: gstCharge.toFixed(2), // Adjust decimal places as needed
    //     cgst_charge: cgstCharge.toFixed(2), // Adjust decimal places as needed
    //     sgst_charge: sgstCharge.toFixed(2), // Adjust decimal places as needed
    //     }));
    // }, [
    //     formData.transportation_charge,
    //     formData.packing_charge,
    //     formData.unpacking_charge,
    //     formData.loading_charge,
    //     formData.unloading_charge,
    //     formData.insurance_charge,
    //     formData.storage_charge,
    //     formData.other_charge,
    //     formData.sgst_per,
    //     formData.cgst_per,
    //     formData.gst_per,
    // ]);
  
    useEffect(() => {
        setFilteredLr(fetchLrReducers.data);
  }, [fetchLrReducers.data]); 

const formatDate = (dateString) => {
    // Agar dateString khali hai, null hai ya "NA" hai, toh khali string return karo
    if (!dateString || dateString === "NA" || dateString === "" || dateString === "0000-00-00") {
        return ""; 
    }

    const date = new Date(dateString);

    // Check karo ki date valid hai ya nahi (RangeError se bachne ke liye)
    if (isNaN(date.getTime())) {
        return "";
    }

    try {
        const formattedDate = date.toISOString().split('T')[0];
        return formattedDate;
    } catch (error) {
        console.error("Format Date Error:", error);
        return "";
    }
};

    
const UpdateLrClick = (LrId) => {
            setselectedLrId(LrId);

            const selectedLr = fetchLrReducers.data.find(lr => lr.id === LrId);

            const defaultTime = new Date();
            defaultTime.setHours(0, 0, 0, 0);

            if (selectedLr) {
                setFormData({
                ...formData,

                /* ================= LR DETAILS ================= */
                lr_date: selectedLr.lr_date ? new Date(selectedLr.lr_date + 'T00:00:00') : defaultTime,
                lr_number: selectedLr.lr_number,
                risk_type: selectedLr.risk_type,
                truck_number: selectedLr.truck_number,

                /* ================= DRIVER ================= */
                driver_name: selectedLr.driver_name,
                driver_phone: selectedLr.driver_phone,
                driver_licence: selectedLr.driver_licence,

                /* ================= CONSIGNOR ================= */
                consignor_name: selectedLr.consignor_name,
                consignor_phone: selectedLr.consignor_phone,
                consignor_gst: selectedLr.consignor_gst,
                consignor_state: selectedLr.consignor_state,
                consignor_city: selectedLr.consignor_city,
                consignor_add: selectedLr.consignor_add,

                /* ================= CONSIGNEE ================= */
                consignee_name: selectedLr.consignee_name,
                consignee_phone: selectedLr.consignee_phone,
                consignee_gst: selectedLr.consignee_gst,
                consignee_state: selectedLr.consignee_state,
                consignee_city: selectedLr.consignee_city,
                consignee_add: selectedLr.consignee_add,

                /* ================= PACKAGE ================= */
                no_package: selectedLr.no_package,
                ac_weight: selectedLr.ac_weight,
                ac_weight_type: selectedLr.ac_weight_type,
                char_weight: selectedLr.char_weight,
                charg_weight_type: selectedLr.charg_weight_type,
                pack_condition: selectedLr.pack_condition,
                pack_desc: selectedLr.pack_desc,
                remark: selectedLr.remark,

                /* ================= FREIGHT ================= */
                f_to_bill: selectedLr.f_to_bill,
                f_paid: selectedLr.f_paid,
                f_to_pay: selectedLr.f_to_pay,
                total_basic_f: selectedLr.total_basic_f,
                loading_charge: selectedLr.loading_charge,
                unloading_charge: selectedLr.unloading_charge,
                st_charge: selectedLr.st_charge,
                other_charge: selectedLr.other_charge,
                lrcn_charge: selectedLr.lrcn_charge,

                gst_per: selectedLr.gst_per,
                gst_paid_by: selectedLr.gst_paid_by,

                /* ================= INSURANCE ================= */
                material_Insu: selectedLr.material_Insu,
                insu_company: selectedLr.insu_company,
                policy_num: selectedLr.policy_num,
                insu_date: selectedLr.insu_date ? new Date(selectedLr.insu_date + 'T00:00:00') : defaultTime,
                insu_amount: selectedLr.insu_amount,
                insu_risk: selectedLr.insu_risk,

                /* ================= DEMURRAGE ================= */
                demurrage_charge: selectedLr.demurrage_charge,
                demurrage_type: selectedLr.demurrage_type,
                demurrage_time: selectedLr.demurrage_time,
                });
            } else {
                console.log("LR not found");
            }

        };

      const imageUrl = `https://app.packersbilling.in/api/${fetchcompanyLogo.data?.[0]?.path}`;
     const [base64URL, setBase64URL] = useState('');
    useEffect(() => {
      const fetchImage2 = async () => {
      try {
          const response = await fetch(imageUrl);
          if (!response.ok) {
          throw new Error(`Failed to fetch image. Status: ${response.status}`);
          }
          const blob = await response.blob();
          const reader = new FileReader();
          reader.onloadend = () => {
          const base64 = reader.result;
          setBase64URL(base64);
          };
          reader.readAsDataURL(blob);
      } catch (error) {
          console.error('Error fetching or converting the image:', error);
      }
      };

      fetchImage2();
  }, [imageUrl]);

     // State for From Location
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [cities, setCities] = useState([]);
  
    // State for To Location
    const [selectedToState, setSelectedToState] = useState(null);
    const [selectedToCity, setSelectedToCity] = useState(null);
    const [toCities, setToCities] = useState([]);
  
    // Get all Indian states
    const states = State.getStatesOfCountry("IN").map((state) => ({
      value: state.isoCode,
      label: state.name,
    }));
  
    // Load Cities when Editing
    useEffect(() => {
      if (formData.from_state) {
        const stateObject = states.find((state) => state.value === formData.from_state);
        setSelectedState(stateObject);
  
        const filteredCities = City.getCitiesOfState("IN", formData.from_state).map((city) => ({
          value: city.name,
          label: city.name,
        }));
  
        setCities(filteredCities);
  
        if (formData.from_city) {
          const cityObject = filteredCities.find((city) => city.value === formData.from_city);
          setSelectedCity(cityObject);
        }
      }
    }, [formData.from_state, states]);
  
    useEffect(() => {
      if (formData.to_state) {
        const stateObject = states.find((state) => state.value === formData.to_state);
        setSelectedToState(stateObject);
  
        const filteredCities = City.getCitiesOfState("IN", formData.to_state).map((city) => ({
          value: city.name,
          label: city.name,
        }));
  
        setToCities(filteredCities);
  
        if (formData.to_city) {
          const cityObject = filteredCities.find((city) => city.value === formData.to_city);
          setSelectedToCity(cityObject);
        }
      }
    }, [formData.to_state, states]);
  
//  const handleDownloadPdf = () => {
//         const element = document.getElementById('content-to-pdf');
//         html2pdf(element, {
//           margin: [8, 5, 20, 5,],
//           filename: 'quotation.pdf',
//           image: { type: 'jpeg', quality: 1 },
//           html2canvas: { scale: 2 },
//           jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait' },
//         });
//       };


// Is calculation ko render function ke andar ya return se pehle rakhein
// Function jo 0 ko "--" mein badal dega
const displayVal = (val) => {
    return (val == 0 || val == null || val == undefined || val == "") ? "--" : val;
};

// Calculations
const subtotalValue = 
    Number(LrData.total_basic_f || 0) + 
    Number(LrData.loading_charge || 0) + 
    Number(LrData.unloading_charge || 0) + 
    Number(LrData.st_charge || 0) + 
    Number(LrData.other_charge || 0) + 
    Number(LrData.lrcn_charge || 0);

const gstAmountValue = (subtotalValue * Number(LrData.gst_per || 0)) / 100;
const grandTotalValue = Math.round(subtotalValue + gstAmountValue);

const toWords = (num) => {
    if (num === 0 || !num) return "";
    const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const makeWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + a[n % 10] : "");
        if (n < 1000) return makeWords(Math.floor(n / 100)) + " Hundred " + (n % 100 !== 0 ? makeWords(n % 100) : "");
        if (n < 100000) return makeWords(Math.floor(n / 1000)) + " Thousand " + (n % 1000 !== 0 ? makeWords(n % 1000) : "");
        if (n < 10000000) return makeWords(Math.floor(n / 100000)) + " Lakh " + (n % 100000 !== 0 ? makeWords(n % 100000) : "");
        return makeWords(Math.floor(n / 10000000)) + " Crore " + (n % 10000000 !== 0 ? makeWords(n % 10000000) : "");
    };

    return makeWords(Math.round(num)) + "Only";
};


// const handleDownloadPdf = (elementId, fileName) => {
//   const element = document.getElementById(elementId);

//   if (!element) {
//     alert("Element not found!");
//     return;
//   }

//      window.scrollTo(0, 0);

//     const options = {
//         margin: [5, 5, 5, 5],
//         filename: `${fileName}.pdf`,
//         image: { type: 'jpeg', quality: 0.98 },
//         html2canvas: {
//         scale: 2,
//         useCORS: true,
//         scrollY: 0,
//         scrollX: 0,
//         windowHeight: element.scrollHeight,
//         logging: false,
//         },
//         jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait' },
//         pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
//     };

//   setTimeout(() => {
//     html2pdf().set(options).from(element).save();
//   }, 100);
// };

const handleDownloadPdf = async (elementId, fileName) => {
  const element = document.getElementById(elementId);

  if (!element) {
    alert("LR Content not found!");
    return;
  }

  window.scrollTo(0, 0);

  const options = {
    margin: [5, 5, 5, 5],
    filename: `${fileName}.pdf`,
    image: { type: 'jpeg', quality: 0.95 }, 
    html2canvas: {
      scale: 2,
      useCORS: true,
      scrollY: 0,
      scrollX: 0,
      windowHeight: element.scrollHeight,
      logging: false,
    },
    jsPDF: { 
      unit: 'mm', 
      format: 'a3', 
      orientation: 'portrait',
      compress: true 
    },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  };

  setTimeout(async () => {
    try {
      const pdfBlob = await html2pdf().set(options).from(element).output('blob');
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isMobile) {
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob); 
        reader.onloadend = async function() {
          const base64data = reader.result;

          const userAction = window.confirm(`Do you want to SHARE "${fileName}"? \n(Click 'Cancel' to just DOWNLOAD)`);

          if (userAction && navigator.share) {
            try {
              const file = new File([pdfBlob], `${fileName}.pdf`, { type: 'application/pdf' });
              await navigator.share({
                files: [file],
                title: fileName,
                text: `Please check the attached LR: ${fileName}`,
              });
            } catch (err) {
              // Share fail/cancel -> Safe Download trigger
              triggerAndroidDownload(base64data, `${fileName}.pdf`);
            }
          } else {
            // DOWNLOAD trigger
            triggerAndroidDownload(base64data, `${fileName}.pdf`);
          }
        }
      } else {
        // --- PC LOGIC ---
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = `${fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.open(pdfUrl, '_blank');
      }
    } catch (error) {
      console.error("LR PDF Error:", error);
      alert("Error generating LR PDF");
    }
  }, 100);
};

// Helper Function (Ensure this is available in your file)
const triggerAndroidDownload = (base64data, fileName) => {
  const link = document.createElement('a');
  link.href = base64data;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  return (
    <>
    {loading && <div className='text-center mt-4'>
        <Loader />
    </div>}
    {!loading && (
    <Row>
       {fetchLrReducers.data && Array.isArray(fetchLrReducers.data) && fetchLrReducers.data.length > 0 ? (
            [...fetchLrReducers.data].reverse().slice(0,1).map(item => {
                
                // --- CALCULATION LOGIC START ---
                const subtotalValue = 
                    Number(item.total_basic_f || 0) + 
                    Number(item.loading_charge || 0) + 
                    Number(item.unloading_charge || 0) + 
                    Number(item.st_charge || 0) + 
                    Number(item.other_charge || 0) + 
                    Number(item.lrcn_charge || 0);

                const gstAmountValue = (subtotalValue * Number(item.gst_per || 0)) / 100;
                const grandTotalValue = Math.round(subtotalValue + gstAmountValue);
                // --- CALCULATION LOGIC END ---
    return (
    
         <div className="container-fluid invoice-container"> 
            <div id='content-to-pdf-lr'>
                <header>
                    <div className="row align-items-center gy-3 header_sec_b">
                        <div className="col-sm-3 text-center text-sm-start">
                            <div>
                                {base64URL ? (
                                    <div>
                                    <img src={base64URL} alt="logo" className='logo'/>
                                    </div>
                                ) : (
                                    <Link to="/update-company" className='btn btn-primary'>Add Logo</Link>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-9 text-center text-sm-end">
                            <h4 className="mb-1">{company_name}</h4>
                            <p className="mb-1"><i className='fa fa-map-marker-alt'></i> {company_add}</p>
                            <div className='d-flex align-items-center justify-content-end mb-1'>
                                <p className="mb-0 mx-2 email"><i className='fa fa-envelope'></i> {email}</p>
                                <p className="mb-0"><i className='fa fa-phone'></i> +91 {phone_number} {phone_number_2 && ( // Check if phone_number_2 exists
                                    <span>, {phone_number_2}</span>
                                )}</p>
                            </div>
                            <div className='d-flex align-items-center justify-content-end'>
                                {company_GST && ( // Check if company_GST exists
                                    <p className="mb-0 mx-2"><i className='fa fa-file'></i> GSTIN : {company_GST}</p>
                                )}
                                {company_website && ( // Check if company_GST exists
                                    <p className="mb-0 text-lowercase"><i className='fa fa-globe-americas'></i> {company_website}</p>
                                )}
                            
                            </div>
                        </div>
                    </div>
                </header>
                <main>
                    <div className="row gy-3">
                        <div className="col-md-12 mt-2 mb-0 p-0">
                            {/* <strong>Quotation Number:</strong> <span>{item.quotation_number}</span>  */}
                             <table className="table table-bordered text-1 my_table mb-0">
                                <tbody>
                                    <tr className="bg-light">
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Notice</strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>
                                            {item.risk_type}
                                        </strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>LR Note</strong></th>
                                    </tr>

                                    <tr>
                                    {/* NOTICE – BIG WIDTH */}
                                        <td colSpan={6} className="notice-cell">
                                            <div className="notice-box">
                                            The consignment by the lorry receipt shall be stored at the destination
                                            under the control of the transport operator and shall be delivered to
                                            the order of the consignee whose name is mentioned in the lorry receipt.
                                            It will under no circumstances be delivered to anyone without written
                                            authorization from the consignee on its order.
                                            </div>
                                        </td>

                                        {/* AT OWNER'S RISK – MEDIUM */}
                                        <td colSpan={6} className="p-0 notice-cell">
                                            <table className="table table-bordered m-0 w-100" style={{ tableLayout: "fixed" }}>
                                            <tbody>
                                                <tr>
                                                <td colSpan={4} className="text-center fw-bold">
                                                    Material {item.material_Insu}
                                                </td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Insurance Company</td>
                                                <td colSpan={2}> {item.insu_company}</td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Policy Number</td>
                                                <td colSpan={2}>
                                                     {item.policy_num}
                                                </td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Insurance Date</td>
                                                <td colSpan={2}><b>{formatDate(item.insu_date)}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Insured Amount</td>
                                                <td colSpan={2}>{displayVal(item.insu_amount)}</td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </td>

                                        {/* LR / CONSIGNMENT NOTE */}
                                        <td colSpan={6} className="p-0 notice-cell">
                                            <table className="table table-bordered m-0 w-100" style={{ tableLayout: "fixed" }}>
                                            <tbody>
                                                <tr>
                                                <td colSpan={4}><b>LR No.</b> &nbsp; {item.lr_number}</td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>LR Data</td>
                                                <td colSpan={2}><b>{formatDate(item.lr_date)}</b></td>
                                                </tr>
                                                
                                                <tr>
                                                <td colSpan={2}>Move From</td>
                                                <td colSpan={2}><b>{item.consignor_city}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Move To</td>
                                                <td colSpan={2}><b>{item.consignee_city}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={2}>Vehicle No.</td>
                                                <td colSpan={2}><b>{item.truck_number}</b></td>
                                                </tr>
                                                <tr>
                                                <td colSpan={4}
                                                    className="text-center fw-bold text-uppercase bg-light-4"
                                                    style={{ background: "", color: "#000" }}>
                                                    Transporter Copy
                                                </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-12 mb-0 p-0 mt-0">
                                <table className="table table-bordered text-1 my_table mb-0">
                                    <tbody>
                                        <tr className="bg-light">
                                            <th colspan="18" className='pt-2 pb-2 pr-1 pl-4 text-center text-white notice-cell'>
                                                <strong>Driver Details </strong>
                                            </th>
                                        </tr>

                                        <tr className="">
                                            <td colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center notice-cell'>
                                                <strong>Driver Name : </strong> {item.driver_name}
                                            </td>
                                            <td colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center notice-cell'>
                                                <strong>Driver Contact No. : </strong> {item.driver_phone}
                                            </td>
                                            <td colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center notice-cell'>
                                                <strong>Driver Licence No. : </strong> {item.driver_licence}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                        
                        <div className="col-md-12 mb-0 p-0 mt-0">
                            {/* <strong>Quotation Number:</strong> <span>{item.quotation_number}</span>  */}
                             <table className="table table-bordered text-1 my_table mb-0">
                                <tbody>
                                    <tr className="bg-light">
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Consignor Details</strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Consignee Details</strong></th>
                                        <th colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white notice-cell'><strong>Freight</strong></th>
                                    </tr>

                                    <tr>
                                    {/* NOTICE – BIG WIDTH */}
                                        <td colSpan={6} className="notice-cell">
                                            <div className="">
                                              <p>Name: <b>{item.consignor_name}</b></p>
                                              <div className='d-flex gap-2'>
                                                <p>Mob: <b>{item.consignor_phone}</b></p>
                                                <p>GST No: <b>{item.consignor_gst}</b></p>
                                              </div>
                                              <p className='mb-0'>Address: <b>{item.consignor_add}</b></p>
                                            </div>
                                        </td>

                                         <td colSpan={6} className="notice-cell">
                                            <div className="">
                                              <p>Name: <b>{item.consignee_name}</b></p>
                                              <div className='d-flex gap-2'>
                                                <p>Mob: <b>{item.consignee_phone}</b></p>
                                                <p>GST No: <b>{item.consignee_gst}</b></p>
                                              </div>
                                              <p className='mb-0'>Address: <b>{item.consignee_add}</b></p>
                                            </div>
                                        </td>
                                        
                                        {/* LR / CONSIGNMENT NOTE */}
                                        <td colSpan={6} className="p-0 notice-cell">
                                            <table className="table table-bordered m-0 w-100" style={{ tableLayout: "fixed" }}>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={2}>Paid</td>
                                                    <td colSpan={2}>
                                                    <b>{displayVal(item.f_paid)}</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}>To Pay</td>
                                                    <td colSpan={2}><b>{displayVal(item.f_to_pay)}</b></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={2}>To Be Billed</td>
                                                    <td colSpan={2}><b>{displayVal(item.f_to_bill)}</b></td>
                                                </tr>
                                                
                                                <tr>
                                                    <td colSpan={2}>GST Paid By</td>
                                                    <td colSpan={2}><b>{item.gst_paid_by}</b></td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-8 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0" style={{ height: '100%' }}>
                                <thead>
                                    <tr className="bg-light text-center text-white notice-cell">
                                        <th colSpan="2" style={{ width: '60%' }}>Packages and Goods Description</th>
                                        <th colSpan="2" style={{ width: '40%' }}>Weight</th>
                                    </tr>
                                    <tr className="text-center">
                                        {/* <th style={{ border: 'none' }}></th> */}
                                        <td colSpan={2}><p className="mb-0 text-start">No. Of Packages: <b>{item.no_package}</b></p></td>
                                        <th>Actual</th>
                                        <th>Charged</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan="2" style={{ verticalAlign: 'top', height: '100px', border: '1px solid #000'}}>
                                            <p className="mb-1">{item.pack_condition}, {item.pack_desc}</p>
                                            <p className="mb-0"><strong>Remark :-</strong>{item.remark}</p>
                                        </td>
                                        <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                            <b>
                                                {displayVal(item.ac_weight)}
                                            </b> <b>
                                                {displayVal(item.ac_weight_type)}
                                            </b>
                                        </td>
                                        <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                            <b>
                                                {displayVal(item.char_weight)}
                                            </b> <b>
                                                {item.charg_weight_type}
                                            </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" className='pb-0'>
                                            <p className='mb-0'><b>Schedule of demurrage charge :-</b></p>
                                            <p className='mb-0'>Demurrage charge after More Than {item.demurrage_time}, @ {item.demurrage_charge} Rupees {item.demurrage_type} + handling & local transportation charges.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" className='pb-0'>
                                            <strong>Total Rupees in Words :-</strong> <span><b>
                                                {item.f_paid && item.f_paid != 0 
                                                    ? toWords(Number(item.f_paid)) 
                                                    : "--"}
                                            </b></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-4 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0">
                                <thead>
                                    <tr className="bg-light text-center text-white notice-cell">
                                        <th colSpan="2">FREIGHT DETAILS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Basic Freight</td>
                                        <td className="text-center">{displayVal(item.total_basic_f)}</td>
                                    </tr>
                                    <tr>
                                        <td>Loading Charge</td>
                                        <td className="text-center">{displayVal(item.loading_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>Unloading Charge</td>
                                        <td className="text-center">{displayVal(item.unloading_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>S.T. Charge</td>
                                        <td className="text-center">{displayVal(item.st_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>Other Charge</td>
                                        <td className="text-center">{displayVal(item.other_charge)}</td>
                                    </tr>
                                    <tr>
                                        <td>LR/CN Charge</td>
                                        <td className="text-center">{displayVal(item.lrcn_charge)}</td>
                                    </tr>

                                    {/* Subtotal Section */}
                                    <tr className="font-weight-bold">
                                        <td>Subtotal</td>
                                        <td className="text-center">{displayVal(subtotalValue)}</td>
                                    </tr>

                                    {/* GST Section */}
                                    <tr>
                                        <td>Gst ({item.gst_per || 0}%)</td>
                                        <td className="text-center">{displayVal(gstAmountValue.toFixed(2))}</td>
                                    </tr>

                                    {/* Total Section (Round Figure) */}
                                    <tr className="bg-light font-weight-bold">
                                        <td>Total</td>
                                        <td className="text-center text-white">
                                            <b>{displayVal(grandTotalValue)}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-8 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0" style={{ height: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td colSpan="4" className=''>
                                            <strong>
                                                I/WE CAREFULLY CHECKED AND VERIFIED THE CONTENT FILLED IN THIS CONSIGNMENT NOTE AND AGREE TO THE TERMS AND CONDITIONS PRINTED OVERLEAF ESPECIALLY THE CLAUSE OF JURISDICTION ALL CHARGES AS PER AGREEMENT
                                            </strong>
                                        </td>
                                    </tr>

                                    {/* <tr>
                                        <td colSpan="4" className=''>
                                            <div>
                                                Consignor Signature
                                            </div>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>                    
                        </div>

                         <div className="col-md-4 mb-0 p-0 mt-0">
                            <table className="table table-bordered text-1 my_table mb-0" style={{ height: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td colSpan="4" className=''>
                                            <h4 className="text-3 mt-4 stemp"><strong>For :</strong> {company_name}</h4>
                                    {[...signatures.data].map((signature, index) => (
                                        <img key={index} src={signature.signature_data} alt={`Signature ${index + 1}`} className='sign-size' />
                                    ))}
                                    {!hasSignature && (
                                        <Link to="/update-company" className='d-print-none btn btn-primary'>
                                            Add Sign
                                        </Link>
                                    )}
                                    <p className='mb-0 stemp'>Authorized Signature</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>                    
                        </div>
                    </div>
                </main>
            </div>

            <div className="hidden-print-content">
                {/* Sabka ID bilkul alag hona chahiye */}
                    <div id="contecontent-to-pdf-transport">
                        <LrdesignTransport data={item} />   
                    </div>
                            
                    <div id="content-to-pdf-consignors">
                        <LrdesignConsignor data={item} /> 
                    </div>
            
                    <div id="content-to-pdf-consignee">
                        <LrdesignConsignee data={item} /> 
                    </div>
            
                    <div id="content-to-pdf-driver">
                        <LrdesignDriverCopy data={item} /> 
                    </div>
            </div>
        
            
            <div className="text-center invoice_design">
                {/* <button
                    onClick={() => item && UpdateLrClick(item.id)}
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#staticBackdropLr"
                    aria-controls="staticBackdropLr" className='btn btn-info bill_btn pt-2 pb-2 d-print-none'>
                    Edit
                </button> */}

                {/* <div className="btn-group btn-group-sm d-print-none">
                    <a href="javascript:window.print()" className="btn btn-info quot_btn pt-2 pb-2"><i className="fa fa-print"></i> Print & Download</a> 
                </div> */}

                {/* <PDFDownloadLink
                    document={
                        <QuotationPDFTemplate 
                            item={item} 
                            company={{ company_name, company_add, email, phone_number, base64URL, company_GST }}
                            bankData={FetchBankReducers.data || []}
                            signatures={signatures.data || []}
                            terms={FeatchTearmsReducers.data || []}
                            />
                        }
                        fileName={`Quotation_${item.quotation_number}.pdf`}
                        className="btn btn-info bill_btn pt-2 pb-2 d-print-none"
                        >
                        {({ loading }) => (loading ? 'Generating...' : 'Download as PDF')}
                </PDFDownloadLink> */}

                <div className="d-flex gap-2 justify-content-center py-3">
                    <button onClick={() => handleDownloadPdf('contecontent-to-pdf-transport', 'Transport_Copy')} className='btn btn-info bill_btn'>
                       Transport Copy
                    </button>
                    
                    <button onClick={() => handleDownloadPdf('content-to-pdf-consignors', 'Consignor_Copy')} className='btn btn-info bill_btn'>
                        Consignor Copy
                    </button>
                    
                    <button onClick={() => handleDownloadPdf('content-to-pdf-consignee', 'Consignee_Copy')} className='btn btn-info bill_btn'>
                        Consignee Copy
                    </button>
                </div>

                <div className="d-flex gap-2 justify-content-center py-3">
                    <button onClick={() => handleDownloadPdf('content-to-pdf-driver', 'Driver_Copy')} className='btn btn-info bill_btn'>
                        Driver Copy
                    </button>

                    <Link class="btn btn-info plus_btn text-white pt-2 pb-2 d-print-none" to="/lr-list">LR List</Link>
                </div>
                
            </div>
        </div>
        
); // 1. Ye Return ( ) wala bracket hai
        }) // 2. Ye .map(item => { }) wala bracket hai
    ) : (
        // 3. Ye Ternary Operator ka "else" part hai
        <div className='text-center not_data mt-3'>
            <i className="fa-solid fa-triangle-exclamation"></i>
            <p>No data available</p>
        </div>
    )}
</Row>
)}
    {/* Popup Component - All Logic is inside this */}
    <LrEditPop LrId={selectedLrId} allData={fetchLrReducers.data} />
</>
)
}

export default Lrdesign